var Theme = Theme || {};

Theme.HashHandler = (function ($) {

    return {
        getHashReference: _getHashReference,
        scrollToSubSection: _scrollToSubSection
    };

    /* This is a means to prevent any browser from attempting to jump to section content
     * This is something handled internally, so we "hide" the jump link from the browser 
     * and handle it internally. This allows us to pass in preFixed hashes for targeting */
    function _getHashReference(preFix) {
        var hash = $(location).attr('hash');
        hash = hash.split('?')[0]; //remove query parameter
        hash = hash.replace(preFix, '');
        return hash;
    }

    function _scrollToSubSection() {
        var hash = _getHashReference('sectionID-');

        try {
            //Find element requested
            var $destination = $(hash);
            if ($destination.length) {
                var $toolbar = $('.toolbar-wrap');
                var toolbarHeight = 0;
                if ($toolbar.length) {
                    $toolbar.addClass('toolbar-stuck');
                    toolbarHeight = $toolbar.outerHeight();
                }

                var destinationTop = $destination.offset().top;
                $(window).scrollTop(destinationTop - toolbarHeight);
            }
        } catch (error) {
            console.error(error);
        }
    }

})(jQuery);